import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  Button,
  Select,
  InputLabel,
  FormControl,
  Snackbar,
  Alert,
  Badge,
  IconButton,
  CircularProgress,
  Card,
  CardContent,
  Divider,
  Stack,
  Chip,
  Tooltip,
} from "@mui/material";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import PersonIcon from "@mui/icons-material/Person";
import EventSeatIcon from "@mui/icons-material/EventSeat";
import { LocalizationProvider, DateTimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useNavigate } from "react-router-dom";
import { _get, _post } from "../../Config/axiosInstance";
import dayjs from "dayjs";

function NewTicketBooking() {
  const navigate = useNavigate();
  const [dateTime, setDateTime] = useState(new Date());
  const [screen, setScreen] = useState("");
  const [movie, setMovie] = useState("");
  const [custid, setCustId] = useState(0);
  const [tickets, setTickets] = useState(1);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [checkLoading, setCheckLoading] = useState(false);
  const [checkexisting, setCheckexisting] = useState(false);
  const [customerdata, setCustomerdata] = useState(null);
  const [ticketSummary, setTicketSummary] = useState(null);
  const [offers, setOffers] = useState([]);
  const [selectedOffer, setSelectedOffer] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    variant: "filled",
    severity: "success",
  });

  const isValidPhoneNumber = (number) => /^\+?[0-9]{10,15}$/.test(number);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (isValidPhoneNumber(phoneNumber)) {
        setCheckLoading(true);
        setCustomerdata(null);
        setCheckexisting(false);
        setTicketSummary(null);

        _get(`/checkMobileNo/${phoneNumber}`)
          .then((res) => {
            const data = res?.data?.data;
            if (data && data.length > 0) {
              const customer = data[0];
              setCheckexisting(true);
              setCustomerdata(customer);
              setCustId(customer.custId);

              if (customer.status === "Inactive") {
                setSnackbar({
                  open: true,
                  message: "This customer is Inactive and cannot book tickets.",
                  severity: "warning",
                });
              }

              // Fetch ticket summary
              _get(`/getCustomerTicketSummary/${customer.custId}`)
                .then((res) => setTicketSummary(res?.data?.data || null))
                .catch((err) => {
                  console.error("Summary error:", err);
                  setTicketSummary(null);
                });
            } else {
              setCheckexisting(false);
              setCustomerdata(null);
              setCustId(0);
              setTicketSummary(null);
            }
          })
          .catch((error) => {
            console.error("Error checking customer details:", error);
            setSnackbar({
              open: true,
              message: "Error checking customer details.",
              severity: "error",
            });
            setCheckexisting(false);
            setCustomerdata(null);
          })
          .finally(() => setCheckLoading(false));
      } else if (phoneNumber) {
        setSnackbar({
          open: true,
          message: "Invalid phone number format. Please enter 10 digits.",
          severity: "warning",
        });
        setCheckexisting(false);
        setCustomerdata(null);
      } else {
        setCheckexisting(false);
        setCustomerdata(null);
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [phoneNumber]);

  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const response = await _get("/getoffers");
        if (Array.isArray(response.data.data)) {
          setOffers(response.data.data);
        } else {
          console.error("Unexpected offers response:", response.data);
        }
      } catch (error) {
        console.error("Failed to load offers:", error);
      }
    };
    fetchOffers();
  }, []);

  const handleSubmit = async () => {
    if (customerdata?.status !== "Active") {
      setSnackbar({
        open: true,
        message: "Inactive customers cannot book tickets.",
        severity: "error",
      });
      return;
    }

    if (!screen || !movie || tickets <= 0 || !phoneNumber || !selectedOffer) {
      setSnackbar({
        open: true,
        message: "Please fill all required fields.",
        severity: "error",
      });
      return;
    }

    // Check offer availment
    if (selectedOffer && custid) {
      try {
        const offerCheckResponse = await _get(
          `/checkOfferAvailment/${custid}/${selectedOffer}`
        );
        if (offerCheckResponse.data?.hasAvailed) {
          setSnackbar({
            open: true,
            message: "This customer has already availed this offer.",
            severity: "warning",
          });
          return;
        }
      } catch (error) {
        console.error("Offer check error:", error);
        setSnackbar({
          open: true,
          message: "Error checking offer usage.",
          severity: "error",
        });
        return;
      }
    }

    try {
      setLoading(true);
      // const response = await _post(`/sendOTP/${phoneNumber}`);
      const response = { data: { data: {} } };
      const serverResponse = response.data?.data?.data;
      console.log("serverResponse", serverResponse);
      const formateddate = dayjs(dateTime).format("YYYY-MM-DD HH:mm");

      // if (serverResponse?.verificationId) {
      if (true) {
        setSnackbar({
          open: true,
          message: "OTP sent successfully!",
          severity: "success",
        });

        const payload = {
          formateddate,
          screen,
          movie,
          tickets,
          phoneNumber,
          custid,
          selectedOffer,
          // verificationId: serverResponse.verificationId,
          verificationId: 1111,
        };

        setTimeout(() => {
          navigate("/OTPAuthPage", { state: payload });
        }, 1000);
      } else {
        throw new Error("Invalid OTP response.");
      }
    } catch (error) {
      console.error("OTP error:", error);
      setSnackbar({
        open: true,
        message: `Failed to send OTP. ${error.message || ""}`,
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const isBookingFormEnabled =
    checkexisting && customerdata?.status === "Active";

  const currentOffer = offers.find((offer) => offer.offerId === selectedOffer);
  const maxAllowedTickets = currentOffer?.offermovietickets || 10;
  const ticketsRemaining = Math.max(
    maxAllowedTickets - (ticketSummary?.totalTickets || 0),
    0
  );

  return (
    <Box sx={{ p: 3, maxWidth: 600, mx: "auto" }}>
      <Card elevation={6} sx={{ p: 3, borderRadius: 4 }}>
        <CardContent>
          <Typography
            variant="h5"
            fontWeight="bold"
            color="primary"
            sx={{ display: "flex", alignItems: "center", mb: 2 }}
          >
            <EventSeatIcon sx={{ mr: 1 }} /> 🎟 Book New Tickets
          </Typography>
          <Divider sx={{ mb: 3 }} />

          <TextField
            fullWidth
            label="Registered Mobile Number"
            placeholder="e.g. 98xxxxxx10"
            type="tel"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            margin="normal"
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
          />

          {checkLoading && (
            <Box mt={2} textAlign="center">
              <CircularProgress size={24} />
            </Box>
          )}

          {!checkLoading &&
            phoneNumber &&
            !checkexisting &&
            isValidPhoneNumber(phoneNumber) && (
              <Alert severity="error" sx={{ mt: 2, borderRadius: 2 }}>
                This mobile number is not registered.
              </Alert>
            )}

          {checkexisting && customerdata && (
            <Box
              sx={{
                my: 3,
                bgcolor: "#f5f5f5",
                p: 2,
                borderRadius: 2,
                border: "1px solid #e0e0e0",
              }}
            >
              <Typography
                variant="subtitle1"
                fontWeight="bold"
                sx={{ display: "flex", alignItems: "center", mb: 1 }}
              >
                <PersonIcon sx={{ mr: 1 }} /> Customer Details
              </Typography>
              <Stack spacing={0.5}>
                <Typography variant="body2">
                  <strong>Name:</strong> {customerdata.custName}
                </Typography>
                <Typography variant="body2">
                  <strong>Phone:</strong> {customerdata.custMobile}
                </Typography>
                <Typography variant="body2">
                  <strong>Email:</strong> {customerdata.custEmail}
                </Typography>
                <Typography variant="body2">
                  <strong>Address:</strong> {customerdata.custAddress}
                </Typography>
                <Typography variant="body2">
                  <strong>DOB:</strong> {customerdata.custDOB}
                </Typography>
                <Box display="flex" alignItems="center">
                  <Typography variant="body2" sx={{ mr: 1 }}>
                    <strong>Status:</strong>
                  </Typography>
                  <Chip
                    label={customerdata.status}
                    color={
                      customerdata.status === "Active" ? "success" : "error"
                    }
                    size="small"
                    sx={{ fontWeight: "bold" }}
                  />
                </Box>
                {ticketSummary && (
                  <>
                    <Divider sx={{ my: 1 }} />
                    <Typography variant="body2">
                      <strong>Total Tickets Booked:</strong>{" "}
                      {ticketSummary.totalTickets}
                    </Typography>
                    {ticketSummary.lastBooking && (
                      <>
                        <Typography variant="body2">
                          <strong>Last Movie:</strong>{" "}
                          {ticketSummary.lastBooking.movieName}
                        </Typography>
                        <Typography variant="body2">
                          <strong>Last Booking Date:</strong>{" "}
                          {new Date(
                            ticketSummary.lastBooking.movieDate
                          ).toLocaleString()}
                        </Typography>
                      </>
                    )}
                  </>
                )}
              </Stack>
            </Box>
          )}

          {!isBookingFormEnabled &&
            checkexisting &&
            customerdata?.status === "Inactive" && (
              <Alert severity="warning" sx={{ mt: 3, borderRadius: 2 }}>
                This customer is Inactive. New bookings cannot be made.
              </Alert>
            )}

          {isBookingFormEnabled && (
            <Stack spacing={2} sx={{ mt: 3 }}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DateTimePicker
                  label="Select Date & Time"
                  value={dateTime}
                  onChange={(newValue) => setDateTime(newValue)}
                  renderInput={(params) => (
                    <TextField
                      fullWidth
                      margin="normal"
                      {...params}
                      sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
                    />
                  )}
                />
              </LocalizationProvider>

              <FormControl
                fullWidth
                margin="normal"
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
              >
                <InputLabel>Select Screen</InputLabel>
                <Select
                  value={screen}
                  onChange={(e) => setScreen(e.target.value)}
                  label="Select Screen"
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value="Screen 1">Screen 1</MenuItem>
                  <MenuItem value="Screen 2">Screen 2</MenuItem>
                  <MenuItem value="IMAX">IMAX</MenuItem>
                </Select>
              </FormControl>

              <TextField
                fullWidth
                label="Movie Name"
                placeholder="Enter Movie Title"
                value={movie}
                onChange={(e) => setMovie(e.target.value)}
                margin="normal"
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
              />

              <FormControl
                fullWidth
                margin="normal"
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
              >
                <InputLabel>Select Offer</InputLabel>
                <Select
                  value={selectedOffer}
                  onChange={(e) => setSelectedOffer(e.target.value)}
                  label="Select Offer"
                >
                  <MenuItem value="">
                    <em>No Offer</em>
                  </MenuItem>
                  {offers.length > 0 ? (
                    offers.map((offer) => (
                      <MenuItem key={offer.offerId} value={offer.offerId}>
                        {offer.offerName}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No offers available</MenuItem>
                  )}
                </Select>
              </FormControl>

              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <TextField
                  fullWidth
                  type="number"
                  label="Number of Tickets"
                  inputProps={{ min: 1 }}
                  value={tickets}
                  onChange={(e) => setTickets(Number(e.target.value))}
                  margin="normal"
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
                />
                <IconButton sx={{ mt: 1 }} disabled>
                  <Tooltip
                    title={`Remaining tickets out of ${maxAllowedTickets}`}
                  >
                    <Badge badgeContent={ticketsRemaining} color="secondary">
                      <ConfirmationNumberIcon />
                    </Badge>
                  </Tooltip>
                </IconButton>
              </Box>

              <Button
                variant="contained"
                color="success"
                fullWidth
                sx={{ mt: 2, borderRadius: 2, py: 1.5, fontWeight: "bold" }}
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? "Sending OTP..." : "Send OTP to Customer"}
              </Button>
            </Stack>
          )}
        </CardContent>
      </Card>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert
          variant="filled"
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default NewTicketBooking;
